import { Modal } from "../../Components/Models/Modal";


class CopyModal extends Modal {

    copyCurrentUrl = () => {
        this.show()
        this.copyUrlLink()
        setTimeout(this.hide, 3000)
    }

    private copyUrlLink = async  () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            return true;
        } catch (err) {
            return false;
        }
    }
}

export { CopyModal }